"use client";

import type React from "react";

import { fieldTypes } from "@/constants/field-types";
import { SchemaField } from "@papier/grapesjs-editor/src/components/editor/schema-builder/types/schema";

interface FieldTypePaletteProps {
  onDragStart: (e: React.DragEvent, fieldType: SchemaField["type"]) => void;
}

export function FieldTypePalette({ onDragStart }: FieldTypePaletteProps) {
  return (
    <div className="w-64 overflow-y-auto border-r p-4 shadow-sm">
      <div>
        <h3 className="mb-4 font-semibold">Field Types</h3>
        <div className="grid grid-cols-2 gap-3">
          {fieldTypes.map(({ value, color, icon: Icon, label }) => (
            <div
              key={value}
              className="hover:bg-secondary flex h-auto cursor-grab flex-col items-center gap-2 rounded-lg border p-3 transition-colors active:cursor-grabbing"
              draggable
              onDragStart={(e) => onDragStart(e, value)}
            >
              <div className={`rounded-lg border p-2 ${color}`}>
                <Icon className="h-4 w-4" />
              </div>
              <span className="text-xs font-medium capitalize">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
